import angular from 'angular';

(function() {
    'use strict';
    angular.module('processdelay').factory('ProcessDelay', ProcessDelayData);

    ProcessDelayData.$inject = ['$translate'];

    /* @ngInject */
    function ProcessDelayData($translate) {
        ProcessDelay.prototype = {
            build: build,
            getStatusLabel: getStatusLabel
        };

        function ProcessDelay(processDelayData) {
            if (processDelayData) {
                this.build(processDelayData);
            }
        }

        return ProcessDelay;

        /////////////////////

        function build(processDelayData) {
            this.batchId = processDelayData.batchId || null;
            this.status = processDelayData.batchStatus || null;
            this.sentDate = processDelayData.sentDate || null;
            this.processedDate = processDelayData.updated || null;
            this.principalName = processDelayData.principalName || null;
            this.companyName = processDelayData.companyName || null;
            this.containerId = processDelayData.containerId || null;
            this.ladProviderId = processDelayData.ladProviderId || null;
            this.ladProviderName = processDelayData.ladProviderName || null;
            this.ladProcessedDelay = processDelayData.ladProcessedDelay || 0;
        }

        function getStatusLabel() {
            if (this.status) {
                return $translate.instant('dashboard.column.batchProcessDelay.status.' + this.status);
            }
            return '';
        }
    }
})();
